<template>
	<div>
		<FormGroupBox
			v-if="modelId > 0 && items.length > 0 && $hasPermission('reservation.additionalService.show')"
			title="Servicios adicionales"
		>
			<b-form-row>
				<b-form-group class="col-12 table-responsive" >
					<b-table class="table-sm" striped hover :items="items" :fields="fields"></b-table>
				</b-form-group>
			</b-form-row>
		</FormGroupBox>

		<FormGroupBox
			v-if="_newAdditionalServices.length > 0 && $hasPermission('reservation.additionalService.show')"
			title="Adicionales del carrito">
			<div class="w-100 row no-gutters u:hover:bg-white-2 py-2"
				v-for="(itemAddtService, indexAS) in _newAdditionalServices" :key="indexAS">


				<div class="w-100 " v-for="(itemRate, indexRate) in itemAddtService.rates" :key="indexRate">

					<div class="w-100" v-if="itemRate.quantity>0">

						<div class="u:h-fit-content d-flex u:text-size-3 single-line" v-if="indexRate==0">
							<strong class="mr-1" v-if="'transportServiceReference' in itemAddtService.related">#{{itemAddtService.related.transportServiceReference.slice(5)}}: </strong>
							<strong class="mr-1" v-else>#Reserva: </strong>
							{{itemAddtService.name}}
						</div>

						<div class="u:h-fit-content d-flex u:text-size-2 " v-if="!itemAddtService.quote.specialRate">
							<label class="m-0 text-capitalize">{{itemRate.quantity+" "+itemRate.category}}</label>
							<label class="m-0 flex-grow-1 ml-4 text-right font-weight-bold u:text-uppercase"><span class="u:text-size-1 u:text-uppercase">{{itemAddtService.currency+"$ "}}</span> {{itemRate.price*itemRate.quantity}}</label>
						</div>

					</div>

				</div>
				<div v-if="itemAddtService.quote.specialRate" class="w-100 mt-1 d-flex justify-content-between u:text-size-2">
					<span>Precio especial <small>({{itemAddtService.quote.specialRateData.reason}})</small></span>
					<b><span class=" text-uppercase">{{itemAddtService.currency+"$ "}}</span> {{itemAddtService.quote.bookingPriceTotal}}</b>
				</div>
			</div>

			<hr>
			<div class="text-success u:text-size-2"><strong>Nota:</strong> Estos registros se efectuaran solo cuando se guarde el actual formulario de reserva</div>
		</FormGroupBox>
	</div>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
export default {
	props:{
		modelId: Number
	},
	components: {
		FormGroupBox
	},
	data(){
		return {
			fields:[
				{ key: 'additionalServiceType.name', label: 'Servicio' },
				{ key: 'quantityResume', label: 'Qty' },
				{ key: 'status', label: 'Status' },
				{ key: 'paymentStatus', label: 'status pago' },
				{ key: 'transportService.serviceNumber', label: 'Ride' },
			],
		}
	},
	computed:{
		viewModel(){
			return this.$store.state.reservation.viewModel
		},
		items(){
			return this.viewModel.additionalServices.filter(item => item.id>0);
		},
		_newAdditionalServices(){
			return this.viewModel.additionalServices.filter(item=>{
				return item.id==-1;
			})
		},
	}
};
</script>
